export const GET_COURSE_SUCCESS = 'GET_COURSE_SUCCESS';
export const FILTER_MAIN_COLLECTION_BOOK = 'FILTER_MAIN_COLLECTION_BOOK';
export const GET_RANKING_LIST_SUCCESS = 'GET_RANKING_LIST_SUCCESS';
export const SET_RANKING_LOADING = 'SET_RANKING_LOADING';
export const GET_DIAGNOSIS_LIST_SUCCESS = 'GET_DIAGNOSIS_LIST_SUCCESS';
export const SET_DIAGNOSIS_LOADING = 'SET_DIAGNOSIS_LOADING';
export const GET_TASK_STATUS_SUCCESS = 'GET_TASK_STATUS_SUCCESS';
export const GET_MY_TASK_STATUS_SUCCESS = 'GET_MY_TASK_STATUS_SUCCESS';
export const SET_TASK_STATUS_LOADING = 'SET_TASK_STATUS_LOADING';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const ADD_VIDEO_TO_FAVORITE_LIST = 'ADD_VIDEO_TO_FAVORITE_LIST';
export const REMOVE_UNFOLLOW_VIDEOS = 'REMOVE_UNFOLLOW_VIDEOS';
export const CLEAR_STATE = 'CLEAR_STATE';
export const LOADING_MESSAGE = 'Course Loading ...';
export const GET_CLASS_RESTRICTION_WEB_TREE_PATH_SUCCESS =
  'GET_CLASS_RESTRICTION_WEB_TREE_PATH_SUCCESS';
export const SET_MATERIAL_LOADING = 'SET_MATERIAL_LOADING';
